import React from 'react'
import { cn } from 'src/lib/cn'

type ButtonType= React.ComponentProps<'button'>

type Props=ButtonType & {
    children:React.ReactNode
    variants?: 'contained' | 'outline';
    className?: string
}
const Button:React.FC<Props> = ({
  variants = 'contained',
  disabled = false,
  className = '',
  children,
  ...restProps
}) => {
  const commonStyles = `rounded-md px-3 py-2 text-sm font-semibold flex justify-center w-full sm:mt-0`;
  const containedStyles = `bg-blue-700 text-white hover:bg-blue-700`;
  const outStyles = `bg-white text-gray-900 ring-1 ring-inset ring-gray-300`;
  const disabledStyles = `bg-gray-400 cursor-not-allowed opacity-50`;

  const buttonStyles = cn(
    commonStyles,
    {
      [containedStyles]: variants === 'contained',
      [outStyles]: variants === 'outline',
      [disabledStyles]: disabled,
    },
    className
  );

  return (
    <button
      type="button"
      className={buttonStyles}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
};

export default Button;

